export const overlay = (isOverlayToggled) => {
  const overlay = document.querySelector(".js-overlay");
  const btnToggleOverlay = document.querySelector(".js-overlay-toggle");
  const btnCloseOverlay = document.querySelector(".js-overlay-close");

  const init = () => {
    updateOverlayState();
    bind();
  };

  const bind = () => {
    if (btnToggleOverlay) {
      btnToggleOverlay.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        isOverlayToggled = !isOverlayToggled;
        updateOverlayState();
      };
    }
      if (btnCloseOverlay) {
        btnCloseOverlay.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          isOverlayToggled = !isOverlayToggled;
          updateOverlayState();
        };
      }
  };

  const updateOverlayState = () => {
    if (isOverlayToggled) {
      overlay.setAttribute("aria-hidden", false);
      overlay.setAttribute("data-state", "open");
      document.body.setAttribute("data-overlay-open", "true");
    } else {
      overlay.setAttribute("aria-hidden", true);
      overlay.setAttribute("data-state", "closed");
      document.body.setAttribute("data-overlay-open", "false");
    }
  };

  init();

};